export default __webpack_public_path__ + "static/grow1-23f6ba802c69a6b55f74b4d12900582a.png";